import { defineComponent as _defineComponent } from 'vue';
import { currentTabInjectKey } from '@/components/_next/molecules/AzTabs.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzTab',
  props: {
    id: null,
    label: null
  },
  setup: function setup(__props) {
    var currentTabId = inject(currentTabInjectKey, undefined);
    return {
      __sfc: true,
      currentTabId: currentTabId
    };
  }
});